import { render, staticRenderFns } from "./ContractDocs.vue?vue&type=template&id=5b8b0f8d&"
import script from "./ContractDocs.vue?vue&type=script&lang=js&"
export * from "./ContractDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports